<template lang="pug">

    v-dialog(v-model='imagenes_dialog')
      template( v-slot:activator="{ on }")
        v-btn( color="primary" icon v-on="on")
          v-icon(small ) fa-camera
      v-card
        v-card-title 
          span Mis imágenes
          Agregar_imagen_boton( )
          v-btn(@click='imagenes_dialog=false' color='primary' text)
            v-icon fa-times
        v-card-text
          v-row
            Imagen_item( cols='3'  v-for='imagen, i in registro' :key='i' seleccionable :imagen='imagen' @_seleccionar_imagen='val=>seleccionar_imagen(val)')
              
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  data: ()=>({
    imagenes_dialog: false,
    seguro_de_borrado: false,
  }),
  methods: {
    seleccionar_imagen(imagen){
      this.$emit('seleccionar_imagen', imagen)
      this.imagenes_dialog = false
    },
  },
  computed:mapGetters({
    registro: 'Imagenes/registro'
  }),
  components: {
    Agregar_imagen_boton: ()=>import('./agregar_imagen_boton.vue'),
    Imagen_item: ()=>import('../../galeria/componenes/imagen_item')
  }
}
</script>